import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { Reveal, WindReveal } from "@/components/Cinematic";

export default function Impact() {
  const [metrics, setMetrics] = useState([]);
  useEffect(() => {
    document.title = "Impact — seedesign";
    api.get("/impact-metrics").then((r) => setMetrics(r.data)).catch(() => {});
  }, []);

  return (
    <div className="pt-28 pb-24">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <p className="text-sm uppercase tracking-[0.2em] text-[#66371B] mb-4">Impact</p>
        <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl tracking-tight text-[#3F3F2C] max-w-4xl leading-[0.95]">
          <WindReveal text="Quiet proof, not loud numbers." />
        </h1>
        <p className="mt-6 max-w-2xl text-lg text-[#3F3F2C]">
          Beautiful work is the baseline. A few outcomes below are shared with our partners&apos; permission — most of what
          we do stays confidential, and we like it that way.
        </p>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-12" data-testid="impact-grid">
          {metrics.map((m, i) => (
            <Reveal key={i} delay={(i % 3) * 0.06} className="border-t border-[#81754B]/30 pt-6">
              <p className="text-xs uppercase tracking-[0.2em] text-[#81754B] mb-3">{m.category}</p>
              <p className="font-serif text-4xl lg:text-5xl text-[#B4833D]">{m.value}</p>
              <p className="mt-3 font-medium text-[#3F3F2C]">{m.label}</p>
              <p className="text-sm text-[#81754B] mt-1">{m.context}</p>
            </Reveal>
          ))}
        </div>

        <div className="mt-20 rounded-sm bg-[#E3D8C1]/70 p-10 lg:p-16 text-center">
          <p className="signature text-3xl text-[#81754B]">Your brand could be the next quiet win.</p>
          <Link to="/contact" data-testid="impact-cta" className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#3F3F2C] px-8 py-4 text-[#F7F1E1] hover:bg-[#66371B] transition-colors">
            Let's create <ArrowRight size={18} />
          </Link>
        </div>
      </div>
    </div>
  );
}
